import Header from "../../Components/Header/Header";
import ThreeWay from "../../Components/MinistryComponent/MinistryComponent";
import "./Momentum.scss";

export default function Momentum() {
  return (
    <div>
      <Header
        img={"./images/normalheader.jpg"}
        logo={"./images/Momentum Logo.png"}
        margin={'2rem'}
      />
      <ThreeWay
        pastorTitle={"Lead Young Adults Pastors"}
        pastorName={"Michael & Jacee Gammill"}
        pastorImage={"/staff-images/Pastor_Michael_Jacee.jpg"}
        missionText={
          <>
            <p>The goal of the Synergy Youth Ministry is to reveal the passion and purpose of Jesus Christ for their lives and teach the full living Word of God as their foundation and center core of their existence.</p><p>Geared for young people from ages 12-18, and/or grades six through twelve. We get together each Wednesday night at 6:30, at Trinity Gospel Temple for a high energy, worship-centered encounter with a loving Heavenly Father. It’s an opportunity to be totally real and transparent, but requires a willingness and determination to be transformed.</p><p>Our youth look forward to several events each year including our ever increasingly popular summer camp. We laugh, cry, and grow together.</p>
          </>
        }
        meetingImage={"/images/momentum.jpg"}
      />
    </div>
  );
}
